import { render } from "./VpsSg.vue?vue&type=template&id=27760e88"
import script from "./VpsSg.vue?vue&type=script&lang=js"
export * from "./VpsSg.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\zoinix-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__